import axios from 'axios'
import { getAuthToken } from './TokenUtility'
const baseURL = process.env.NODE_ENV === 'production'
  ? 'https://dev-backoffice.tribe.sn'
  : '';

const backofficeApi = axios.create({ baseURL });
backofficeApi.interceptors.request.use((config: any) => {
  const token = getAuthToken()
  if (token) {
    config = {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      },
    }
  }
  return config
})
export default backofficeApi
